import styled from 'styled-components';

import {
  HeaderPrefix as DefaultHeaderPrefix,
  ModalHeader as DefaultModalHeader,
} from './styled.default';

export * from './styled.default';

export const ModalHeader = styled(DefaultModalHeader)`
  font-weight: 900;
`;

export const HeaderPrefix = styled(DefaultHeaderPrefix)`
  font-size: 1.125rem;
  ${Styles.desktop`
    font-size: 1.5rem;
  `}
`;
